/*
 * Copyright (c) 2021 Well Solutions SRL. All Rights Reserved.
 * This software is the proprietary information of Well Solutions SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Directive, Input } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, Validator, ValidatorFn } from '@angular/forms';
import { ErrorModel } from '../model/error.model';
import { ErrorSeverityEnum } from '../consts/error-severity.enum';
import * as moment from 'moment';

//TODO rename to iriroDateRangeValidator
@Directive({
  selector: '[dateRangeValidator], [iriro-dateRangeValidator]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: CustomDateRangeValidator,
      multi: true,
    }
  ],
})
export class CustomDateRangeValidator implements Validator {
  @Input() fieldName = '';
  @Input() minDateValue = new Date();

  validate(control: AbstractControl): { [key: string]: any } | null {
    const funcProperties = {
      field: this.fieldName,
      min: this.minDateValue,
    };

    return _customDateRangeValidation?.bind(funcProperties)(control);
  }
}

export const customDateRangeValidation = (
  fieldName = '',
  minDateValue?: Date
): ValidatorFn => {
  const funcProperties = {
    field: fieldName,
    min: minDateValue ? minDateValue : new Date(),
  };

  return _customDateRangeValidation.bind(funcProperties);
};

function _customDateRangeValidation(this: any, control: AbstractControl): {
  [key: string]: any;
} | null {
  let errors: ErrorModel | null = null;
  if (
    control &&
    control.value &&
    control.value[0] &&
    moment(control.value[0]).isBefore(moment(this.min).subtract(1, 'days'))
  ) {
    errors = {
      severity: ErrorSeverityEnum.error,
      message: 'selectedDateAfterCurrentDate' + this.field,
    };
  }
  return errors ? errors : null;
}
